import { useQuery } from "@apollo/client";
import Link from "next/link";
import { usePath } from "../../../contexts/path/path";
import { SERVICE_RATES_QUERY } from "../../../graphql/queries/rating";
import css from "./.module.scss";

const ReviewsButton = () => {
  const { city, direction, district } = usePath();
  const { data } = useQuery(SERVICE_RATES_QUERY, {
    variables: {
      district_id: district?.id,
    },
  });

  const districtRate = data?.Rating?.getDistrictRate?.rate?.toFixed(1);
  return (
    <Link
      href={{
        pathname: `/district-reviews/${city.uri}/${
          direction?.uri ? `${direction.uri}/` : ""
        }${district.uri}`,
      }}
      passHref
      shallow
    >
      <button
        type="button"
        className={css.districtReviewsButton}
        size="x-small"
      >
        <span>{`تقييم ${district.name}`}</span>
        <span className={css.rate}>
          <svg
            width={15}
            height={15}
            viewBox="0 0 15.791 15.001"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.48,9.846l4.311-3.735-5.677-.482L7.9.395,5.677,5.629,0,6.111,4.311,9.846,3.016,15.4,7.9,12.451,12.775,15.4Z"
              transform="translate(0 -0.395)"
              fill="#fc0"
            />
          </svg>
          <span>{districtRate}</span>
        </span>
      </button>
    </Link>
  );
};
export default ReviewsButton;
